import axios from "axios";

export const locationsWithNewWalkins = [
  'alexandria',
  'atlanta',
  'charlotte',
  'chicago (west loop)',
  'chicago',
  'colorado springs',
  'dallas',
  'denver downtown',
  'fresno',
  'indianapolis',
  'long beach',
  'minneapolis',
  'minneapolis (city center)',
  'oklahoma',
  'rochester',
  // 'san francisco',
  'spanish fort',
  'syracuse',
  'burlington',
  'mississauga',
  'ottawa',
  'surrey',
  'waterloo',
  // 'winnipeg',
  'vaughan',
];

export const locationsWithSocialLanes = [
  'atlanta',
  'long beach',
  'chicago',
  'denver',
  'denver downtown',
  'colorado springs',
  'alexandria',
  'mississauga',
  'burlington',
  'charlotte',
  'dallas',
  'fresno',
  'indianapolis',
  'minneapolis',
  'minneapolis (city center)',
  'oklahoma',
  'ottawa',
  'rochester',
  'surrey',
  'syracuse',
  'waterloo'
];

export const locationsWithBookingExtension = [
  // Canada locations
  'burlington',
  'mississauga',
  'ottawa',
  'surrey',
  'waterloo',
  // USA locations
  'alexandria',
  'atlanta',
  'charlotte',
  'chicago (west loop)',
  'colorado springs',
  'dallas',
  'denver',
  'fresno',
  'indianapolis',
  'long beach',
  'minneapolis',
  'minneapolis (city center)',
  'oklahoma',
  'rochester',
  'san francisco',
  'spanish fort',
  'syracuse',
];

export const locationsWithKnifeThrowing = [
  "alexandria",
  "atlanta",
  "charlotte",
  "chicago",
  "chicago (west loop)",
  "colorado springs",
  "dallas",
  "denver",
  "denver downtown",
  "fresno",
  "indianapolis",
  "long beach",
  "minneapolis",
  "minneapolis (city center)",
  "oklahoma city",
  "rochester",
  "syracuse",
  "burlington",
  "mississauga",
  "ottawa",
  "waterloo",
];

export const locationsWithBigAxeThrowing = [
  "alexandria",
  "atlanta",
  "colorado springs",
  "charlotte",
  "chicago (lake view)",
  "chicago (west loop)",
  "chicago",
  "dallas",
  "denver",
  "denver downtown",
  "indianapolis",
  "long beach",
  "minneapolis",
  "minneapolis (city center)",
  "oklahoma city",
  "rochester",
  "syracuse",
  "burlington",
  "ottawa",
  "waterloo",
  "surrey",
];

export const locationsWithCorkageAddon = [
  'dallas',
];

export const externalLocations = [
  'nashville',
  'windsor',
  'waldorf' 
];

export const getWalkinRate = (locationName: string) => {
  // Check the student type
  let student = 19.99;
  let standard = 26.98;
  let all = 36.98;

  // Windsor
  if (locationName.toLowerCase() === "windsor") {
    student = 19.99;
    standard = 25.98;
    all = 36.98;
  }

  if (locationsWithNewWalkins.includes(locationName.toLowerCase())) {
    student = 27.75;
    standard = 19.99;
    all = 36.99;
  }

  // // Alexandria
  // if (locationName.toLowerCase() === "alexandria") {
  //   student = 27.75;
  //   standard = 19.99;
  //   all = 36.99;
  // }
  //
  // // Charlotte
  // if (locationName.toLowerCase() === "charlotte") {
  //   student = 27.75;
  //   standard = 19.99;
  //   all = 36.99;
  // }
  //
  // if (locationName.toLowerCase() === "colorado springs") {
  //   student = 27.75;
  //   standard = 19.99;
  //   all = 36.99;
  // }

  if (locationName.toLowerCase() === 'winnipeg') {
    student = 27.75;
    standard = 19.99;
    all = 36.99;
  }

  // return 
}

/**
 * Get Booking Rate
 */
export const getBookingRate = (location: string) => {
  if (location.toLowerCase() === 'winnipeg') {
    return `$175`;
  }

  if (!externalLocations.includes(location.toLowerCase())) {
    return `$39.99 <sup class="text-base -top-4">/person</sup>`;
  }

  return `$34.99 <sup class="text-base -top-4">/person</sup>`;
}

/**
 * Get Weekday Team Building Rate
 */
export const getWeekdayTeamBuildingRate = (location: string) => {

  if (location.toLowerCase() === 'winnipeg') {
    return `<sup class="text-xl top-0 left-2 absolute">$</sup>350`;
  }

  return `<sup class="text-xl top-0 left-2 absolute">$</sup>450`;
}

/**
 * Locations with rental lanes
 */
export const isRentalLaneLocation = (locationName: string) => {
  if (locationName == null) return false;

  const locationsWithRentalLanes = ['winnipeg'];

  return locationsWithRentalLanes.includes(locationName.toLowerCase());
}

/**
 * Get the team building summary of activities screen
 */
export const teamBuildingActivitySummary = (bookingType = null) => {
  if (bookingType != 'team-building') return ``;

  return `
  <div class="mt-6 mb-4 w-full mx-auto pr-6">
    <h3 class="text-brand text-xl mb-2">Summary of Activities:</h3>
    <ul
      class="list-disc list-outside pr-4 pl-4 pb-4 pt-0 text-sm text-brand font-semibold"
    >
      <li>
        Demonstration and Practice of 3 techniques (2 hand throw, 1 hand
        throw & underhand throw)
      </li>
      <li>Team building games and tournament</li>
      <li>Allotted times for food breaks, speeches, etc</li>
    </ul>
  </div>
  `;
};

export const isRentalLaneBookingWeekend = (date: any) => {
  if (date.getDay() == 5 || date.getDay() == 6) return true;
  return false;
};

export const isLocationWithAdvancedBooking = (location: string) => {
  const locationsWithoutAdvancedBookings = [
    'windsor',
    'winnipeg'
  ];

  if (locationsWithoutAdvancedBookings.includes(location.toLowerCase())) return false;
  return true;
};

// setBookSessionStorage
export const setBookSessionStorage = (process: Object) => {
  let bookProcess = process;
  sessionStorage.setItem('book_process', JSON.stringify(bookProcess));
  const bookEvent = new CustomEvent('bookProcessEvent', {
    detail: bookProcess
  });
  window.dispatchEvent(bookEvent);
}

export const createSocialLanesTimeslots = (from: string, to: string) => {
  const startTime: Date = new Date(`2000-01-01T${from}:00`);
  const endTime: Date = new Date(`2000-01-01T${to}:00`);
  const timeSlots: { [key: string]: string[] } = {};
  const increment: number = 15 * 60 * 1000; // 15 minutes in milliseconds

  let currentTime = new Date(startTime);

  while (currentTime <= endTime) {
    const currentHours = String(currentTime.getHours()).padStart(2, "0");
    const currentMinutes = currentTime.getMinutes();
    const currentTimeFormatted = `${currentHours}:${String(currentMinutes).padStart(2, "0")}`;
    const roundedHourKey = `${currentHours}:00`;

    if (currentMinutes === 0 && currentTime < endTime) {
      timeSlots[roundedHourKey] = [];
      let nextTime = new Date(currentTime.getTime() + increment);
      timeSlots[roundedHourKey].push(`${roundedHourKey}`);
      while (nextTime <= endTime && nextTime.getHours() === parseInt(currentHours, 10)) {
        const nextMinutes = String(nextTime.getMinutes()).padStart(2, "0");
        timeSlots[roundedHourKey].push(`${currentHours}:${nextMinutes}`);
        nextTime.setTime(nextTime.getTime() + increment);
      }
    }

    currentTime.setTime(currentTime.getTime() + increment);
  }

  return timeSlots;
};


/**
 * Get the social lanes list for the calendar
 */
export const getSocialLanesList = async (location: string = "") => {
  if (location === "") return [];

  try {
    const response = await axios.get(
      `/wp-json/badaxe/v1/social-lanes/${location}`
    );
    return response.data || [];
  } catch (error) {
    console.log(error);
    return [];
  }
}

/**
 * Filter dates for social lanes
 */
export const filterSocialLanesDates = (dates: string[], selectedDate: string) => {
  return dates.filter((date) => date !== selectedDate);
}

export const filterDatesForCalendar = (dates: { date: string, from: string, to: string, selected: boolean, lanes: number }[]) => {
  // Handle case where dates might be an object with numeric keys instead of an array
  let datesArray = dates;
  if (dates && typeof dates === 'object' && !Array.isArray(dates)) {
    datesArray = Object.values(dates);
  }

  // Ensure we have an array before mapping
  if (!Array.isArray(datesArray)) {
    console.warn('filterDatesForCalendar: dates is not an array', dates);
    return [];
  }

  return datesArray.map((date) => date?.date);
}

// Check if it's a non-taxed location
export const checkNonTaxedLocation = (locationName: string) => {
  const nonTaxedLocations = [
    'colorado springs',
    'denver downtown',
    'fresno',
    'indianapolis',
    'long beach',
    'rochester',
    'syracuse'
  ];

  if (nonTaxedLocations.includes(locationName.toLowerCase())) return true;

  return false;
};
